import AutoHeightTextarea from './components/AutoHeightTextarea.js'
const { createApp, ref, computed } = Vue

// メールアドレスの正規表現
const REG_EMAIL = /^[a-z\d][\w.-]*@[\w.-]+\.[a-z\d]+$/i

createApp({
  components: { AutoHeightTextarea },
  setup() {
    // フォームの定義
    const forms = ref(FORMS)

    // 入力値
    const inputs = ref(getInitInputs())

    // メール本文用データ
    const zip = ref(null)

    // 送信中
    const isBusy = ref(false)

    // エラーメッセージ
    const errors = ref([])

    // システムエラー
    const isSystemError = ref(false)

    // zipデータの読み込み完了ステータス
    const isReady = computed(() => !!zip.value)

    // 送信完了オブジェクト
    const results = ref(null)

    // zipデータを読み込む
    getZipData().then((value) => {
      zip.value = value
    })

    // メールテキストを返却する
    async function getMailText(fileName) {
      return await zip.value.file(fileName).async('text')
    }

    // フォームの初期値を返却する
    function getInitInputs() {
      return FORMS.reduce((acc, item) => {
        return { ...acc, [item.key]: '' }
      }, {})
    }

    // フォームを初期化する
    function refresh() {
      inputs.value = getInitInputs()
      results.value = null
    }

    // フォーム送信処理
    async function submit(type) {
      isBusy.value = true
      try {
        // メールデータを取り出す
        const mail = await getMailText(`${type}.txt`)

        // 入力データのバリデーション
        if (!validateInputData()) {
          return
        }

        const data = {
          ...getURLParams(),
          ...inputs.value,
        }

        // reCAPTCHAのtokenを取得する
        const token = await getRecaptchaToken()

        // データを送信する
        results.value = await post({ mail, data, token })

        // GTM
        const thanksTitle = `送信完了 | ${results.value.api.formSignature} - ${results.value.api.form}`
        const thanksSlug = results.value.thanks.slug
        gtmSendPageView(thanksTitle, thanksSlug)
      } catch (err) {
        // 送信失敗
        isSystemError.value = true
      } finally {
        isBusy.value = false
      }
    }

    // 入力値のバリデーションを行う
    function validateInputData() {
      // エラーをリセットする
      errors.value = []

      // 必須項目
      forms.value.forEach((form) => {
        // 空白を除去する
        inputs.value[form.key] = inputs.value[form.key].trim()

        // 必須項目
        if (!!form.reuierd && !inputs.value[form.key]) {
          errors.value.push(`${form.label}を入力してください。`)
        }

        if (inputs.value[form.key] && form.rules) {
          // email
          if (form.rules.includes('email')) {
            if (!REG_EMAIL.test(inputs.value[form.key])) {
              errors.value.push(`${form.label}に誤りがあります。`)
            }
          }
        }
      })

      return errors.value.length === 0
    }

    return {
      isReady,
      isBusy,
      forms,
      inputs,
      errors,
      isSystemError,
      results,
      submit,
      refresh,
    }
  }
}).mount('#app')


// URLパラメータを取得して返却する
function getURLParams() {
  const params = new URLSearchParams(location.search)
  return {
    utm_source: params.get('utm_source') || '',
    utm_medium: params.get('utm_medium') || '',
    utm_campaign: params.get('utm_campaign') || '',
    utm_term: params.get('utm_term') || '',
  }
}

// ZIPファイルからデータを取り出して返却する
function getZipData() {
  return new Promise(async (resolve, reject) => {
    const response = await fetch('./data.zip')
    if (!response.ok) {
      console.log('データの読み込みに失敗しました')
      return reject(response.statusText)
    }
    const buffer = await response.arrayBuffer()
    const zip = await JSZip.loadAsync(buffer)
    resolve(zip)
  })
}

// reCAPTCHAのtokenを取得する
async function getRecaptchaToken() {
  return new Promise((resolve, reject) => {
    grecaptcha.ready(async () => {
      try {
        const token = await grecaptcha.execute(RECAPTCHA_SITE_KEY, { action: 'submit' })
        resolve(token)
      } catch (err) {
        console.log(err)
        reject('reCAPTCHAエラーが発生しました。')
      }
    })
  })
}

// APIにデータを送信する
async function post({ mail, data, token }) {
  try {
    const response = await fetch('/api/v1/submit', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ mail, data, token })
    })

    if (!response.ok) {
      throw new Error('error')
    }

    return await response.json()
  } catch (err) {
    console.log(err)
    throw new Error('フォームの送信に失敗しました。')
  }
}

// GTM
function gtmSendPageView(thanksTitle, thanksSlug) {
  const url = new URL(location.href)
  const directory = url.pathname.replace(/\/[^/]+$/, '')

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'cvPageview',
    pageLocation: `https://${url.host}${directory}${thanksSlug}`,
    pageTitle: thanksTitle,
    pageReferrer: location.href,
  })
}
